const IconMaterialAlbumNew = ({
  color = "#6C6C70",
  width = 15,
  height = 15,
  id,
  className,
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id={id}
      className={className}
      style={style}
    >
      <path
        d="M5.90034 0H10.9765C11.1462 0 11.2755 0 11.3886 0.0116048C11.7755 0.0530619 12.1429 0.195698 12.4506 0.423873C12.7583 0.652048 12.9945 0.956949 13.1332 1.30514H3.74365C3.88235 0.956949 4.11853 0.652048 4.42626 0.423873C4.734 0.195698 5.10142 0.0530619 5.48824 0.0116048C5.60136 0 5.73065 0 5.90034 0Z"
        fill={color}
      />
      <path
        d="M4.30121 1.93412C3.28953 1.93412 2.46046 2.58398 2.18411 3.44582C2.17821 3.4638 2.17255 3.48185 2.16714 3.49997C2.45642 3.40714 2.75702 3.34525 3.06246 3.30424C3.8487 3.19671 4.84179 3.19671 5.99489 3.19671H11.0072C12.1603 3.19671 13.1534 3.19671 13.9389 3.30424C14.2443 3.34525 14.5449 3.40636 14.8358 3.49997C14.8304 3.48185 14.8247 3.4638 14.8188 3.44582C14.5417 2.58398 13.7126 1.93412 12.7017 1.93412H4.30121Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9326 8.49994C12.6614 8.49994 13.2522 7.9403 13.2522 7.24995C13.2522 6.5596 12.6614 5.99996 11.9326 5.99996C11.2037 5.99996 10.6129 6.5596 10.6129 7.24995C10.6129 7.9403 11.2037 8.49994 11.9326 8.49994ZM11.9326 7.74994C12.2241 7.74994 12.4604 7.52609 12.4604 7.24995C12.4604 6.97381 12.2241 6.74995 11.9326 6.74995C11.641 6.74995 11.4047 6.97381 11.4047 7.24995C11.4047 7.52609 11.641 7.74994 11.9326 7.74994Z"
        fill={color}
      />
      <path
        d="M1.44649 8.49555L1.03613 6.35773C0.800479 5.13005 1.79618 3.99997 3.11351 3.99997H13.8894C15.2068 3.99997 16.2024 5.13005 15.9668 6.35773L14.6232 13.3577C14.5947 13.5058 14.5495 13.6475 14.4896 13.7814C14.3856 14.0137 14.2374 14.2222 14.0555 14.3982C13.9897 14.462 13.9194 14.5215 13.8453 14.5764C13.4845 14.8433 13.0317 15 12.5458 15H7.24369C7.45022 14.6915 7.6196 14.356 7.74544 13.9999H12.5458C12.6549 13.9999 12.7608 13.9841 12.8606 13.9545L9.08708 11.5717C8.73247 11.3477 8.27048 11.3477 7.91586 11.5717L7.9068 11.5774C7.83583 11.2368 7.72635 10.9103 7.58314 10.6027C8.24942 10.2977 9.04512 10.3433 9.67269 10.7396L13.5788 13.2062C13.5808 13.1971 13.5827 13.188 13.5845 13.1788L14.9281 6.17884C15.0459 5.565 14.5481 4.99996 13.8894 4.99996H3.11351C2.45485 4.99996 1.957 5.56501 2.07482 6.17884L2.44819 8.12394C2.09641 8.2083 1.76071 8.33398 1.44649 8.49555Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50146 16C5.43446 16 7.00146 14.433 7.00146 12.5C7.00146 10.567 5.43446 9 3.50146 9C1.56847 9 0.00146484 10.567 0.00146484 12.5C0.00146484 14.433 1.56847 16 3.50146 16ZM3.75146 11C3.75146 10.8619 3.63954 10.75 3.50146 10.75C3.36339 10.75 3.25146 10.8619 3.25146 11V12.25H2.00146C1.86339 12.25 1.75146 12.3619 1.75146 12.5C1.75146 12.6381 1.86339 12.75 2.00146 12.75H3.25146V14C3.25146 14.1381 3.36339 14.25 3.50146 14.25C3.63954 14.25 3.75146 14.1381 3.75146 14V12.75H5.00146C5.13954 12.75 5.25146 12.6381 5.25146 12.5C5.25146 12.3619 5.13954 12.25 5.00146 12.25H3.75146V11Z"
        fill={color}
      />
    </svg>
  );
};

export default IconMaterialAlbumNew;
